export interface Category {
  id: string;
  name: string;
  slug: string;
  description: string;
  icon: string;
  count: number;
  color: string;
}

export const categories: Category[] = [
  {
    id: 'c1',
    name: '角色扮演',
    slug: 'rpg',
    description: '沉浸式角色扮演游戏，体验史诗级的冒险故事',
    icon: 'ri-sword-line',
    count: 156,
    color: 'accent',
  },
  {
    id: 'c2',
    name: '动作冒险',
    slug: 'action',
    description: '紧张刺激的动作冒险，挑战你的操作极限',
    icon: 'ri-rocket-line',
    count: 234,
    color: 'primary',
  },
  {
    id: 'c3',
    name: '策略模拟',
    slug: 'strategy',
    description: '运筹帷幄的策略模拟，考验你的智慧与决策',
    icon: 'ri-brain-line',
    count: 189,
    color: 'secondary',
  },
  {
    id: 'c4',
    name: '休闲益智',
    slug: 'casual',
    description: '轻松愉快的休闲游戏，随时随地放松心情',
    icon: 'ri-emotion-happy-line',
    count: 312,
    color: 'accent',
  },
  {
    id: 'c5',
    name: '恋爱养成',
    slug: 'dating-sim',
    description: '甜蜜浪漫的恋爱养成，体验心动故事',
    icon: 'ri-heart-line',
    count: 98,
    color: 'primary',
  },
  {
    id: 'c6',
    name: '恐怖解谜',
    slug: 'horror',
    description: '悬疑烧脑的恐怖解谜，挑战你的心理承受力',
    icon: 'ri-ghost-line',
    count: 76,
    color: 'secondary',
  },
];